/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Subscription tier information
 * @export
 * @interface Tier
 */
export interface Tier {
    /**
     * 
     * @type {string}
     * @memberof Tier
     */
    code: TierCodeEnum;
    /**
     * 
     * @type {number}
     * @memberof Tier
     */
    monthlyPriceCents: number;
    /**
     * 
     * @type {number}
     * @memberof Tier
     */
    yearlyPriceCents: number;
    /**
     * 
     * @type {number}
     * @memberof Tier
     */
    creditRateCents: number;
    /**
     * 
     * @type {object}
     * @memberof Tier
     */
    features?: object | null;
}


/**
 * @export
 */
export const TierCodeEnum = {
    Free: 'free',
    Starter: 'starter',
    Pro: 'pro',
    Expert: 'expert'
} as const;
export type TierCodeEnum = typeof TierCodeEnum[keyof typeof TierCodeEnum];


/**
 * Check if a given object implements the Tier interface.
 */
export function instanceOfTier(value: object): value is Tier {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('monthlyPriceCents' in value) || value['monthlyPriceCents'] === undefined) return false;
    if (!('yearlyPriceCents' in value) || value['yearlyPriceCents'] === undefined) return false;
    if (!('creditRateCents' in value) || value['creditRateCents'] === undefined) return false;
    return true;
}

export function TierFromJSON(json: any): Tier {
    return TierFromJSONTyped(json, false);
}

export function TierFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tier {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'monthlyPriceCents': json['monthlyPriceCents'],
        'yearlyPriceCents': json['yearlyPriceCents'],
        'creditRateCents': json['creditRateCents'],
        'features': json['features'] == null ? undefined : json['features'],
    };
}

export function TierToJSON(json: any): Tier {
    return TierToJSONTyped(json, false);
}

export function TierToJSONTyped(value?: Tier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'monthlyPriceCents': value['monthlyPriceCents'],
        'yearlyPriceCents': value['yearlyPriceCents'],
        'creditRateCents': value['creditRateCents'],
        'features': value['features'],
    };
}

